var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_dom-create.js
// module id = 34
// module chunks = 0 3 4 5 6 7 8 9 10 12 13 16 17 18 19 20 21 22 23 24 25 26 27 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 46 48 49 52 53 54 55 56 59 60 61 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 82 83 84 85 87 88 89 91 92 93 94 95 96 97 100 101 102 103 104 105 106 109 111 112 113 114 115 116 117 118 119 120 121 125 127 128 129 133 134 135 138 140 141 142 143 144 145 146 147 148 149 150 151 153 154 155 156 157 159 161 162 163 164 165 166 168 169 170 171 172 173 174